import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Nav, NavItem } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import RsHelp from "components/rshelp/rsHelp";

const ProjectTabNavigation = ({ navItems }) => {
  const location = useLocation();

  return (
    <Row>
      <Col lg="10">
        <Nav tabs className="projectTab projectNav">
       {/* <NavItem>
              <Link 
                className={`nav-link active-help`} 
                to="#"
              >
                <span className="d-none d-sm-block"><i className='bx bxs-right-arrow' style={{verticalAlign:'middel'}}></i></span>
              </Link>
            </NavItem>  */}
          {navItems.map((item, index) => (
            <NavItem key={index}>
              <Link 
                className={`nav-link ${location.pathname.includes(item.id) ? 'active' : ''}`} 
                to={item.link}
              >
                <span className="d-none d-sm-block">{item.label}</span>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </Col>
      <Col lg="2">
          <RsHelp />
      </Col>
    </Row>
  );
};

ProjectTabNavigation.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

export default ProjectTabNavigation;
